import React from 'react';

export const CompareCandidates = React.createContext({
  candidates: [],
  addItem: () => {
  },
  removeItem: () => {
  }
});